import RESTDispatchService from 'src/services/RESTDispatchService';

const restDispatchService = new RESTDispatchService();

export const SET_ALL_DISPATCH_STATUS_AND_STATE_MAPPINGS = '@types/set-all-dispatchstatus-and-state-mapping';

export function setAllDispatchStatusAndStateMapping() {
  return async (dispatch) => {
    const response = await restDispatchService.getDispatchStatusAndStateMapping();
    dispatch({
      type: SET_ALL_DISPATCH_STATUS_AND_STATE_MAPPINGS,
      payload: response?.data
    });
  };
}
